<template>
  <div>
    <hr-filterable-select
      :list="state.countries"
      v-model="state.field"
      :errorMessage="state.field.fieldError"
      data-test-id="hr-country-field"
      @validate="validateField"
      @update:model-value="updateValue"
    />
  </div>
</template>

<script>
import { reactive, computed } from 'vue';
import HrFilterableSelect from '@/components/hr-filterable-select.vue';
import { validate } from '@/core/validation/validation';
import countries from '@/core/country.json';
import store from '@/store';

export default {
  name: 'hr-country-field',
  components: {
    HrFilterableSelect,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:model-value', 'focus'],
  setup(props, { emit }) {
    const countryCode = store.state.onboarding?.countryCode;
    let countriesFrozen = Object.freeze(countries);
    const state = reactive({
      field: computed({
        get: () => props.modelValue,
        set: updateValue,
      }),
      countries: mapOptions(),
    });

    function mapOptions() {
      countriesFrozen = countriesFrozen.filter(
        (country) => country.code !== countryCode
      );

      return countriesFrozen.reduce((totalCountries, current) => {
        const countryObj = {
          value: current.code,
          label: current.country,
          key: current.code,
        };

        return [...totalCountries, countryObj];
      }, []);
    }

    function updateValue(value) {
      const field = value;
      field.valueObj = {
        unformatted: field.value,
        value: field.value,
      };
      field.fieldError = '';
      emit('focus', field);
      validateField();
      emit('update:model-value', field);
    }

    function validateField() {
      validate(state.field);
    }

    function initialize() {}

    initialize();

    return {
      state,
      updateValue,
      validateField,
    };
  },
};
</script>
